/* eslint-disable consistent-return */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unescaped-entities */
import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Carousel, Image, Button, Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { mobileComputer, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function DesktopStickyCarousel({ srcs, redirectUrl }) {
  const validImages = srcs.filter((s) => s && s.file)
  const [showCarousel, setShowCarousel] = useState(true)

  const containerRef = useRef(null)

  const getPreviewURL = (file) => {
    if (file instanceof File || file instanceof Blob) {
      return URL.createObjectURL(file)
    }
    if (typeof file === 'string') return file
    return ''
  }

  return (
    <div
      ref={containerRef}
      className="scroller-hide"
      style={{
        maxHeight: '30.5vh',
        width: '100%',
        height: 'auto',
        overflow: 'auto',
        marginTop: '20%',
      }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobileComputer}
          style={{ width: '38rem', right: '3%', bottom: '25%' }}
        />
        <Row
          className="d-flex border-bottom mb-3"
          style={{ width: '100%', height: '55px', zIndex: '0' }}
        >
          <Col xs={11} className="w-90 m-auto ms-auto">
            <Image
              src={wavenet_logo}
              style={{ height: '45px' }}
              className="ps-3"
            />
          </Col>
          <Col
            xs={1}
            className="m-auto ms-auto d-flex"
            style={{ height: '45px' }}
          >
            <FontAwesomeIcon
              icon={faMagnifyingGlass}
              className="text-end my-auto"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={9} style={{ height: 'auto' }}>
            <div style={{ position: 'relative' }}>
              <div className="text-title" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-ban1" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line2" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
            </div>
            {showCarousel && validImages.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '29%',
                  width: '500px',
                  maxHeight: '150px',
                  right: '7.75%',
                  overflowY: 'hidden',
                  zIndex: 1500,
                }}
              >
                <Carousel className="w-100 mx-auto px-3">
                  {validImages.map((src, idx) => (
                    <Carousel.Item key={idx}>
                      <button
                        type="button"
                        onClick={() => {
                          if (redirectUrl) window.open(redirectUrl, '_blank')
                        }}
                        style={{
                          border: 'none',
                          padding: 0,
                          background: 'transparent',
                          cursor: 'pointer',
                          width: '100%',
                          height: '100%',
                        }}
                      >
                        <img
                          className="d-flex w-100"
                          src={getPreviewURL(src.file)}
                          alt={src.label}
                          style={{
                            objectFit: 'cover',
                            height: '150px',
                            pointerEvents: 'none',
                          }}
                        />
                      </button>
                    </Carousel.Item>
                  ))}
                </Carousel>

                <Button
                  onClick={() => setShowCarousel(false)}
                  className="position-absolute"
                  style={{
                    top: '-20px',
                    right: '0',
                    width: '24px',
                    height: '24px',
                    fontSize: '12px',
                    background: 'rgba(0, 0, 0, 0.5)',
                    border: 'none',
                    padding: '0',
                    borderRadius: '50%',
                    zIndex: '1501',
                  }}
                >
                  ✕
                </Button>

                <CIIcon right="2%" bottom="8%" />
              </div>
            )}
          </Col>
          <Col xs={3}>
            <div style={{ position: 'relative' }}>
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <br />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <br />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
            </div>
          </Col>
        </Row>
      </div>

      <div style={{ position: 'relative' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

DesktopStickyCarousel.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  redirectUrl: PropTypes.string,
}

DesktopStickyCarousel.defaultProps = {
  srcs: [],
  redirectUrl: '',
}

export default DesktopStickyCarousel
